import type { GenderType } from '../util/types';
import type User from '@whizz/api-client/dist/@types/model/User';
import { useIdentity } from '@whizz/react-identity';

export const useGenderIcon = () => {
  const { me } = useIdentity();
  const getIcon = (icon: GenderType | 'primary' | 'black') => {
    if ([ 'primary', 'black' ].includes(icon)) {
      return icon;
    }
    const user = (me as User);
    if (user?.country) {
      if ([ 'nz' ].includes(user.country)) {
        return 'male';
      }
    }
    return icon;
  };

  return [ getIcon ];
};
